<template>
    <div class="header-section">
        <p class="form-subtitle" style="cursor: pointer;" @click="$router.push('/gallery-photo-list')">
            <i class="fa fa-arrow-left"></i> Back
        </p>
        <h1 class="form-title">Club Pioneers, Presidents, Board of Trustees, Executive Setup</h1>
        <p class="form-subtitle">Edit</p>
    </div>
    <form @submit.prevent="submitForm">
        <div class="setup-form">
            <div class="row">
                <!-- Category -->
                <div class="form-group">
                <label for="category">Category</label>
                <select id="category" required v-model="category">
                    <option disabled value="">-- Select Category --</option>
                    <option value="pioneers">Our Pioneers</option>
                    <option value="pastpresidents">Past Presidents</option>
                    <option value="boardoftrustees">Board of Trustees</option>
                    <option value="currentexecutive">Current Executive Committee</option>
                </select>
                </div>
                
                <!-- Description -->
                <div class="form-group">
                    <div class="form-group">
                <label for="date">Fullname</label>
                <input 
                    type="text" 
                    id="title"
                    placeholder="Enter fullname"
                    required 
                    v-model="fullname"
                />
                </div>

            </div>

            <div class="row">
                <div class="form-group">
                <label for="category">Title</label>
                <input 
                    type="text" 
                    id="title"
                    placeholder="Enter title"
                     
                    v-model="title"
                />
                </div>

                
            </div>
       
            <div class="row mt-3">
                <!-- Date -->
                <label style="text-align: left;" for="description">About</label>
                <textarea 
                    id="description"
                    placeholder="Type about here..." 
                    rows="3" 
                     
                    v-model="about"
                ></textarea>
                </div>
                
            </div>
        </div>
        <!-- File Upload Section -->
        <p style="color: #232321; font-weight: 600; font-size: 16px; text-align: center;">Image</p>
        <div @click="triggerFileInput" class="upload-section">
            <!-- Hidden input -->
            <input 
                type="file" 
                ref="fileInput" 
                class="hidden" 
                accept="image/jpeg, image/png" 
                @change="handleFileChange" />

            <!-- Show existing image if available -->
            <div v-if="existingImageUrl" class="existing-image-preview">
                <img :src="existingImageUrl" alt="Current image" class="current-image" width="100px" height="100px" />
                <p class="image-note">Click to change current image</p>
            </div>

            <!-- Default upload UI when no existing image -->
            <div v-else>
                <Image size="32" style="margin-bottom: 10px;" />
                <p style="padding: 0%; margin: 0%;">Drop your image here, or browse</p>
                <p style="padding: 0%; margin: 0%;">Jpeg, png are allowed</p>
            </div>
        </div>

        <!-- File list with progress - Show only when uploading new files -->
        <div class="file-list-section" v-if="files.length > 0">
            <div class="file-item" v-for="file in files" :key="file.name">
                <img v-if="file.preview" :src="file.preview" alt="preview" class="file-preview" />
                <p class="file-name">
                    {{ file.name.replace(/\.[^/.]+$/, "") }}
                </p>
                <div class="progress-container">
                    <div class="progress-bar" :style="{ width: file.progress + '%' }"></div>
                </div>
                <CircleCheck v-if="file.progress === 100" style="color: #DB6813;" />
                <CircleCheck v-else style="color: #00000033;" />
            </div>
        </div>

       
        <div class="buttons">
            <button>Submit</button>
        </div>
    </form>
</template>
<script setup>
/* eslint-disable */ 
import { CircleCheck, Image } from "lucide-vue-next";
import { ref, reactive, computed, onMounted, onBeforeUnmount } from "vue";
import axios from 'axios';
import router from "@/router";
import { useRoute } from 'vue-router'

// In setup function
const route = useRoute()

const fileInput = ref(null);
const files = ref([]);
const dataList = ref([]);
let category = ref('');
let fullname = ref('')
let title = ref('');
let about = ref('')
let dataId = ref('');
const existingImageUrl = ref(''); // Add this for existing image
const existingFileName = ref('');
const created_by = ref(localStorage.getItem('userid'));
let base_url = process.env.VUE_APP_BASE_LIVE_URL

onMounted( async () => {
    dataId.value = route.params.id
    await listRecords()
});

function triggerFileInput() {
    fileInput.value.click();
}

function handleFileChange(event) {
    const selectedFile = event.target.files[0]; // only one banner at a time

    if (selectedFile) {
        const fileObj = reactive({
            name: selectedFile.name,
            file: selectedFile,
            progress: 0,
            preview: selectedFile.type.startsWith("image/")
                ? URL.createObjectURL(selectedFile)
                : null
        });
        files.value = [fileObj]; // replace with new file

        // Clear existing image preview when new file is selected
        existingImageUrl.value = null;
        existingFileName.value = '';
    }

    event.target.value = "";
}

const listRecords = async () => {
  try {
    const response = await axios.get(`/edit_gallery_photo.php?id=${dataId.value}`, { });
    if (response.data.status){
     dataList.value = response.data.data;
     category.value = dataList.value.category
     fullname .value= dataList.value.fullname
     title.value = dataList.value.title
     about.value = dataList.value.about
     // Handle existing file/image display
     if (dataList.value.photo) {
      // If base_url is defined somewhere in your code
            existingImageUrl.value = base_url + dataList.value.photo;
            // Extract file name from path for display
            existingFileName.value = extractFileName(dataList.value.photo);
            
            // Don't put the photo string directly into files array
            // Clear any existing files to avoid the error
            files.value = [];
     }
    }
    else console.error(response.data.message);
  } catch (error) {
    console.error(error.message);
  }
};

// Helper function to construct full image URL
const getFullImageUrl = (imagePath) => {
    if (!imagePath) return '';
    
    // If it's already a full URL, return as is
    if (imagePath.startsWith('http')) return imagePath;
    
    // If it's a relative path, construct full URL
    const baseUrl = window.location.origin;
    return `${baseUrl}/${imagePath.replace(/^\//, '')}`;
};

async function submitForm() {
    const formData = new FormData();
    formData.append("id", dataId.value);
    formData.append("category", category.value);
    formData.append("fullname", fullname.value);
    formData.append("title", title.value);
    formData.append("about", about.value);
    formData.append("updated_by", created_by.value);
    
    // Check if user selected a new image
    const hasNewImage = files.value.length > 0 && files.value[0].file;
    
    if (hasNewImage) {
        formData.append("photo_image", files.value[0].file);
        console.log("New image selected for upload");
    } else {
        console.log("No new image selected - keeping existing image");
    }

    try {
        const response = await axios.post(
            "/executive_setup_update.php",
            formData,
            {
                headers: { "Content-Type": "multipart/form-data" },
                onUploadProgress: (e) => {
                    // Only track progress if uploading a new file
                    if (hasNewImage) {
                        files.value[0].progress = Math.round(
                            (e.loaded * 100) / e.total
                        );
                    }
                }
            }
        );
        
        alert(response.data.message);
        
        // Reset form
        category.value = "";
        fullname.value = "";
        title.value = "";
        about.value = "";
        files.value = [];
        existingImageUrl.value = "";
        existingFileName.value = "";
        
        router.push("/gallery-photo-list");
        
    } catch (error) {
        console.error(error);
        alert(error.response ? error.response.data.message : error.message);
    }
}
</script>
<style scoped>
.setup-form {
    max-width: 95%;
    margin: 0 auto;
    padding: 24px;
    display: flex;
    justify-content: between;
    gap: 24px;
    align-items: start;
}

.header-section {
    max-width: 90%;
    margin: 0 auto 20px auto;
}

.header {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 24px;
    width: 50%;
    box-shadow: #6C757D33 0px 1px 3px 0px, #6C757D1A 0px 1px 2px 0px;
    border: 1px solid #EBF1FF;
    border-radius: 20px;
    padding: 40px;
}

.form-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: start;
    width: 100%;
    margin-top: 20px;
}

.form-group label {
    font-size: 16px;
    color: #495057;
}

.form-group input {
    width: 100%;
    padding: 12px 16px;
    border: 1px solid #94A3B8;
    border-radius: 8px;
    font-size: 16px;
    outline: none;
    transition: border-color 0.3s;
}

.form-group select {
    width: 100%;
    padding: 12px 16px;
    border: 1px solid #94A3B8;
    border-radius: 8px;
    font-size: 16px;
    outline: none;
    transition: border-color 0.3s;
}

.form-group textarea {
    width: 100%;
    padding: 12px 16px;
    border: 1px solid #94A3B8;
    border-radius: 8px;
    font-size: 16px;
    outline: none;
    transition: border-color 0.3s;
    resize: vertical;
}

.form-group input:focus {
    border-color: #4C6EF5;
}

.buttons {
    display: flex;
    justify-content: space-between;
    gap: 16px;
    width: 90%;
    margin: 0 auto 40px auto;
}

.buttons button {
    flex: 1;
    padding: 12px 16px;
    border: none;
    border-radius: 8px;
    font-size: 16px;
    cursor: pointer;
    outline: none;
    transition: background-color 0.3s, color 0.3s;
}

.buttons button:first-child {
    background-color: #FF1F25;
    color: #fff;
}

.buttons button:first-child:hover {
    background-color: #c92f34;
    color: #fff;
}

.buttons button:last-child {
    background-color: #ED4E24;
    color: #fff;
}

.buttons button:last-child:hover {
    background-color: #d35533;
    color: #fff;
}

.form-title {
    text-align: left;
    font-size: 24px;
    font-weight: 600;
    margin-top: 20px;
    color: #020617;
}

.form-subtitle {
    text-align: left;
    font-size: 16px;
    color: #020617;
    margin-bottom: 20px;
}

.upload-section {
    margin-top: 20px;
    padding: 20px;
    border: 2px dashed #ccc;
    border-radius: 12px;
    text-align: center;
    background: #fafafa;
    max-width: 90%;
    height: 180px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 20px auto;
}

.upload-section input[type="file"] {
    display: none;
}

.file-list-section {
    max-width: 90%;
    padding: 10px;
    margin: 15px auto;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}

.file-item {
    background-color: #FAFAFA;
    border: 1px solid #ccc;
    width: 50%;
    margin-top: 15px;
    text-align: left;
    border-radius: 8px;
    padding: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;
}

.file-name {
    font-size: 12px;
    font-weight: bold;
    color: #333;
    padding: 0%;
    margin: 0%;
    width: 20%;
}

.progress-container {
    height: 4px;
    width: 80%;
    background: #eee;
    border-radius: 10px;
    position: relative;
}

.progress-bar {
    height: 100%;
    background: red;
    border-radius: 10px;
    transition: width 0.3s;
}

.progress-container span {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    font-size: 12px;
    font-weight: bold;
    color: #fff;
}

.file-preview {
    width: 40px;
    height: 40px;
    object-fit: cover;
    border-radius: 4px;
}

@media (max-width: 768px) {
    .setup-form {
        flex-direction: column;
        padding: 0px;
        max-width: 100%;
        margin: 0%;
    }

    .header {
        width: 100%;
        padding: 20px;
    }

    .buttons {
        flex-direction: column;
        width: 100%;
        margin: 0 auto 20px auto;
    }

    .upload-section {
        margin-top: 20px;
        padding: 20px;
        max-width: 100%;
        height: auto;
        margin: 10px auto;
    }

    .file-list-section {
        max-width: 100%;
        padding: 8px;
        margin: 12px auto;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
    }

    .file-item {
        background-color: #FAFAFA;
        border: 1px solid #ccc;
        width: 100%;
        margin-top: 15px;
        text-align: left;
        border-radius: 8px;
        padding: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 16px;
    }

}
</style>